export interface BreadcrumbItem {
  text: string;
  to?: any;
  disabled?: boolean;
}

const homeBase = { text: "Home", to: { name: "home" } };
const setupBase = { text: "Farm Setup", to: { name: "setup" } };

export function homeBreadcrumbs(...items: BreadcrumbItem[]): BreadcrumbItem[] {
  return [{ ...homeBase }, ...items];
}

export function setupBreadcrumbs(...items: BreadcrumbItem[]): BreadcrumbItem[] {
  return [{ ...homeBase }, { ...setupBase }, ...items];
}

interface DetailBreadcrumbOptions {
  listText: string;
  listRoute: string;
  currentText: string;
}

function ensureAbsolutePath(path: string): string {
  if (!path) {
    return "/";
  }
  return path.startsWith("/") ? path : `/${path}`;
}

export function setupDetailBreadcrumbs(options: DetailBreadcrumbOptions): BreadcrumbItem[] {
  const listItem: BreadcrumbItem = {
    text: options.listText,
    to: { path: ensureAbsolutePath(options.listRoute) },
  };

  const currentItem: BreadcrumbItem = {
    text: options.currentText,
    disabled: true,
  };

  return setupBreadcrumbs(listItem, currentItem);
}

export function formatDetailBreadcrumbLabel(label: string, identifier?: string | number | null): string {
  if (identifier === undefined || identifier === null) {
    return `New ${label}`;
  }
  const trimmed = String(identifier).trim();
  return trimmed ? `${label} (${trimmed})` : `New ${label}`;
}
